import React, { useState } from "react";
import { Button, Modal, Alert as BSAlert } from "react-bootstrap";
import Alert from "react-s-alert";
import SalesPersonTasksService from "../utils/SalesPersonTasksService";

const NO_SALE_REASONS = [
  { value: "couldnt_afford", label: "Couldn't afford it" },
  { value: "no_longer_interested_-_student", label: "No Longer Interested - Student" },
  { value: "no_longer_interested_-_parent", label: "No Longer Interested - Parent" },
  { value: "wanted_tutor", label: "Wanted a tutor instead" },
  { value: "other", label: "Other" }
];

const BulkNoSaleModal = ({ show, tasks, onClose, onComplete }) => {
  const [reason, setReason] = useState("");
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  const markNoSale = () => {
    setSaving(true);
    SalesPersonTasksService.bulkNoSale(tasks.map(t => t.id), reason, notes)
      .then(data => {
        const skipped = data.skipped || [];
        if (data.updated > 0) {
          Alert.success(
            `${data.updated} deal${data.updated === 1 ? "" : "s"} marked as No Sale and removed from tasks.`
          );
        }
        if (skipped.length > 0) {
          Alert.warning(
            `${skipped.length} deal${skipped.length === 1 ? " was" : "s were"} skipped: ${skipped
              .map(s => `#${s.deal_id || "-"} (${s.reason})`)
              .join(", ")}`
          );
        }
        if (data.updated === 0 && skipped.length === 0) {
          Alert.warning("No deals were updated.");
        }
        setSaving(false);
        onComplete();
      })
      .catch(error => {
        const errorMsg = (error && error.data && error.data.error) || "Failed to mark deals as No Sale";
        Alert.error(errorMsg);
        setSaving(false);
      });
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          Mark {tasks.length} Deal{tasks.length === 1 ? "" : "s"} as No Sale
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <BSAlert bsStyle="warning">
          <div>This marks the selected deals as No Sale and removes their overdue tasks.</div>
          <div>Deals already updated as a sale, or already closed, are skipped automatically.</div>
        </BSAlert>

        <div className="form-group">
          <label className="control-label">Reason for not making the sale</label>
          <select
            className="form-control input-sm"
            value={reason}
            onChange={e => setReason(e.target.value)}
          >
            <option value="">-- select --</option>
            {NO_SALE_REASONS.map(item => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="control-label">Notes</label>
          <textarea
            className="form-control input-sm"
            rows={3}
            value={notes}
            onChange={e => setNotes(e.target.value)}
          />
        </div>

        <div className="text-muted" style={{ fontSize: 12 }}>
          Deals: {tasks.map(t => `#${t.deal_id}`).join(", ")}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onClose} disabled={saving}>
          Whoops, cancel this
        </Button>
        <Button onClick={markNoSale} disabled={!reason || tasks.length < 1 || saving} bsStyle="danger">
          {saving ? "Updating..." : "Mark as No Sale"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BulkNoSaleModal;
